import { useEffect, useState } from "react";
import OutlinedTitle from "../../components/OutlinedTitle";
import LogoFooter from "../../components/LogoFooter";
import Fade from "../../components/Fade";
import DelayedLinkWithFadeout from "../../components/utils/DelayedLinkWithFadeout";
import { useNavigate, useLocation } from "react-router-dom";
import ErrorPopup from "../../components/PopupError/ErrorPopup";
import PaginatedQuestions from "../../components/PaginateQuestions";

export default function Pesquisa() {
  const [notas, setNotas] = useState([]);
  const [perguntas, setPerguntas] = useState([]);
  const [showError, setShowError] = useState(false);

  const [paginaAtual, setPaginaAtual] = useState(0);
  const perguntasPorPagina = 4;
  const totalPaginas = Math.ceil(perguntas.length / perguntasPorPagina);
  const isLastPage = paginaAtual === totalPaginas - 1;

  const navigate = useNavigate();

  const location = useLocation();
  const servico = location.state.servico;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/perguntas`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        setPerguntas(data);
      })
      .catch((error) => console.log(error));
  }, []);

  function handleNext() {
    if (!perguntas.length) return;

    if (isLastPage) {
      if (notas.length === 0 || !servico) {
        setShowError(true);
        return;
      }

      enviarPesquisa();
    } else {
      setPaginaAtual((prev) => prev + 1);
    }
  }

  function dataNota(data, id) {
    setNotas((prevNotas) => {
      const notaExistente = prevNotas.find((nota) => nota.pergunta_id === id);

      if (notaExistente) {
        return prevNotas.map((nota) =>
          nota.pergunta_id === id ? { ...nota, nota: data } : nota,
        );
      }

      return [...prevNotas, { pergunta_id: id, nota: data }];
    });
  }

  function enviarPesquisa() {
    const dadosPesquisa = {
      servico,
      sistema: null,
      respostas: notas.map((n) => ({ pergunta: n.pergunta_id, nota: n.nota })),
    };

    localStorage.setItem("dadosPesquisa", JSON.stringify(dadosPesquisa));

    navigate("/comentario");
  }

  return (
    <>
      <Fade>
        <div className="w-full min-h-screen flex flex-col justify-between px-12 pt-12 pb-4">
          <div className="flex flex-col flex-1">
            <div className="mb-12">
              <h1 className="text-6xl font-bold text-deepBlue">
                Pesquisa de avaliação do serviço
              </h1>
            </div>

            <div className="mb-12 max-w-7xl">
              <p className="text-2xl text-deepBlue leading-relaxed">
                De 1 a 5 estrelas, sendo 1 estrela totalmente insatisfeito e 5
                totalmente satisfeito, classifique abaixo:
              </p>
            </div>

            {perguntas.length > 0 && (
              <PaginatedQuestions
                perguntas={perguntas}
                sendDataStar={dataNota}
                paginaAtual={paginaAtual}
                perguntasPorPagina={perguntasPorPagina}
                notas={notas}
              />
            )}

            <ErrorPopup
              show={showError}
              Erro="Erro de envio"
              message="Por favor, avalie pelo menos uma pergunta antes de enviar."
              onClose={() => setShowError(false)}
            />
            {isLastPage || totalPaginas === 1 ? (
              <div className="px-6 relative w-full flex justify-center mb-8" />
            ) : (
              <div className="px-6 relative w-full flex h-32 justify-center mb-8" />
            )}
          </div>

          <div className="w-full flex items-center justify-between">
            <div className="flex gap-6 items-center">
              <DelayedLinkWithFadeout to="/">
                <button className="min-w-[200px] py-4 bg-blue-100 text-deepBlue px-12 rounded-2xl text-3xl font-semibold">
                  Cancelar
                </button>
              </DelayedLinkWithFadeout>
              {paginaAtual === 0 ? (
                <DelayedLinkWithFadeout to="/servico">
                  <button className="min-w-[200px] py-4 border-2 border-deepBlue text-deepBlue px-12 rounded-2xl text-3xl font-semibold transition">
                    Voltar
                  </button>
                </DelayedLinkWithFadeout>
              ) : (
                <button
                  onClick={() => setPaginaAtual((prev) => prev - 1)}
                  className="min-w-[200px] py-4 border-2 border-deepBlue text-deepBlue px-12 rounded-2xl text-3xl font-semibold transition"
                >
                  Voltar
                </button>
              )}
              <button
                onClick={handleNext}
                className="min-w-[200px] py-4 bg-deepBlue text-white px-12 rounded-2xl text-3xl font-semibold hover:bg-opacity-90 transition"
              >
                Avançar
              </button>
            </div>

            <div className="p-6">
              <LogoFooter />
            </div>
          </div>
        </div>
      </Fade>
    </>
  );
}
